import * as React from 'react';
import {IConviction} from '../../../../../../data/api/models';
import {Col, ControlLabel, FormGroup, Row} from 'react-bootstrap';
import {Field, FieldArray} from 'redux-form';
import {
  isRequired,
  normalizeCurrency,
  normalizeYear,
  isNotShorterThan, isValidDob, minAge, maxAge, isValidDate,
} from '../../../../../../util/validators';
import FieldFormControl from '../../../../../../components/FieldFormControl';
import * as moment from 'moment';
import SelectControl from '../../../../../../components/SelectControl';
import FaCheck from 'react-icons/fa/check';
import { get } from 'lodash';
import TitleField from '../../../../../../components/TitleField';
import AlternativeDatePicker from '../../../../../../components/AlternativeDatePicker';
import FaTrash from 'react-icons/fa/trash';

interface IConvictionProps {
  index: number;
  conviction: IConviction;
  name: string;
  dispatch: any;
  change: any;
  convictionOptions: any;
  convictionDescriptions: any;
  deleteConviction: any;
  removable: boolean;
}

class Conviction extends React.Component<IConvictionProps> {
  public componentWillReceiveProps(nextProps) {
    const { dispatch, change, name, convictionDescriptions } = this.props;

    if (nextProps.conviction.code && this.props.conviction.code !== nextProps.conviction.code) {
      dispatch(change(name + '.description', convictionDescriptions[nextProps.conviction.code]));
    }
  }

  private handleDeleteConviction = (index) => (e) => {
    const { deleteConviction } = this.props;
    deleteConviction(index);
  }

  private renderConvictionCode() {
    const { name, convictionOptions } = this.props;

    return (
      <Row>
        <Col componentClass={ControlLabel} sm={6}>
          Please provide the conviction code:
        </Col>
        <Col sm={4}>
          <FormGroup controlId={'conviction.code'}>
            <Col sm={12} className="no-padding-left">
              <Field
                type="text"
                name={name + '.code'}
                component={SelectControl}
                validate={[ isRequired ]}
                options={convictionOptions}
                placeholder="Please Select"
              />
            </Col>
          </FormGroup>
        </Col>
      </Row>
    );
  }

  private renderConvictionDescription() {
    const { conviction } = this.props;

    return (
      <Row>
        <Col componentClass={ControlLabel} sm={6} style={{ marginBottom: '15px' }}>
          Description of Conviction:
        </Col>
        <Col sm={6}>
          {conviction.description}
        </Col>
      </Row>
    );
  }

  private renderConvictionDate() {
    const { name } = this.props;

    return (
      <FormGroup controlId="conviction.date">
        <Col componentClass={ControlLabel} sm={6}>
          Date of the conviction
        </Col>
        <Col sm={6}>
          <div className="alternative-date-picker">
            <div className="field">
              <Field
                name={name + '.date'}
                id={name + '-date-text-field'}
                type="masked-date"
                placeholder="dd/mm/yyyy"
                component={FieldFormControl}
              />
            </div>
            <div className="icon">
              <Field
                name={name + '.date'}
                maxDate={moment()}
                component={AlternativeDatePicker}
                validate={[
                  isRequired,
                  isValidDate,
                ]}
              />
            </div>
          </div>
        </Col>
      </FormGroup>
    );
  }

  private renderPoints() {
    const { name } = this.props;

    return (
      <Row>
        <Col componentClass={ControlLabel} sm={6}>
          Number of Points:
        </Col>
        <Col sm={4}>
          <FormGroup controlId={'conviction.points'}>
            <Col sm={12} className="no-padding-left">
              <Field
                name={name + '.points'}
                component={FieldFormControl}
                isNumber={true}
                placeholder="0"
              />
            </Col>
          </FormGroup>
        </Col>
      </Row>
    );
  }

  private renderBanned() {
    const { name } = this.props;

    return (
      <Row>
        <Col componentClass={ControlLabel} sm={6}>
          Number of months banned:
        </Col>
        <Col sm={4}>
          <FormGroup controlId={'conviction.banned'}>
            <Col sm={12} className="no-padding-left">
              <Field
                name={name + '.banned'}
                component={FieldFormControl}
                isNumber={true}
                placeholder="0"
              />
            </Col>
          </FormGroup>
        </Col>
      </Row>
    );
  }

  private renderFine() {
    const { name } = this.props;

    return (
      <Row>
        <Col componentClass={ControlLabel} sm={6}>
          Fine amount:
        </Col>
        <Col sm={4}>
          <FormGroup controlId={'conviction.fine'}>
            <Col sm={12} className="no-padding-left">
              <Col sm={10}>
                <Field
                  addOn={'£'}
                  addOnClassName={['input-group-vehicle-value']}
                  currency={true}
                  type="inputGroup"
                  name={name + '.fine'}
                  normalize={normalizeCurrency}
                  component={FieldFormControl}
                  placeholder="0"
                />
              </Col>
            </Col>
          </FormGroup>
        </Col>
      </Row>
    );
  }

  public render() {
    const {index, conviction, removable} = this.props;

    return (
      <div className="sub-title">
        <Row>
          <Col sm={11} className="vehicle-info-centre-subtitle">
            Conviction {index + 1}
          </Col>
          {removable && (
            <Col sm={1}>
              <div
                className="pointer"
                onClick={this.handleDeleteConviction(index)}
              >
                <FaTrash />
              </div>
            </Col>
          )}
        </Row>
        {this.renderConvictionCode()}
        {this.renderConvictionDescription()}
        {conviction.code && (
          <>
            {this.renderConvictionDate()}
          </>
        )}
        {conviction.date && (
          <>
            {this.renderPoints()}
            {this.renderBanned()}
            {this.renderFine()}
          </>
        )}
      </div>
    );
  }
}

export default Conviction;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/Drivers/components/Conviction/index.tsx